// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prop-types */

import React, { useRef } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';
import {
	renderMarkRule,
	renderNodeRule,
	StructuredText,
	// eslint-disable-next-line import/no-unresolved
} from 'react-datocms/structured-text';
import { isHeading } from 'datocms-structured-text-utils';
import { TrustpilotBusinessReviewHorizontal } from '../../../atoms/trustpilot-business-review';
import { BusinessReviewHorizontal } from '../../../atoms/business-reviews';
import { Button } from '../../../atoms/button';
import HeaderBg from '../../../../images/glu-new-header-bg/new-header.png';
import ModalWrapper from '../../molecules/modal-wrapper';
import VideoPlayer from '../../molecules/video-player';
import useModal from '../../../../hooks/modal';
import { PBSLink } from '../../../atoms/link';

const HeroWithCards = ({
	hero,
	googleReview,
	locale,
	rating,
	privateVideoHash,
}) => {
	const footerData = useStaticQuery(graphql`
		query footerDataBatches {
			allDatoCmsGluFooter {
				nodes {
					badgesRowOne {
						alt
						url
						gatsbyImageData(height: 80, layout: CONSTRAINED)
					}
					id
					locale
					showTrustpilot
					title
				}
			}
		}
	`);

	const footerDataForLocale = footerData.allDatoCmsGluFooter.nodes.filter(
		(node) => node.locale === locale
	);

	const { badgesRowOne } = locale !== 'en-AU' && footerDataForLocale[0];

	const ref = useRef();
	const { isModalOpen, setModalOpen } = useModal(ref);

	return (
		<>
			<div className="bg-brand-pale-400 w-full h-max relative flex flex-col">
				<div
					className="w-[70%] h-full  grid-cols-1 place-self-end z-10 absolute -right-[450px] 2xl:block hidden"
					style={{
						backgroundImage: `url(${HeaderBg})`,
						backgroundPosition: 'right',
						backgroundSize: 'cover',
						backgroundRepeat: 'no-repeat',
					}}
				/>
				<div className="grid grid-cols-1 lg:grid-cols-2 pb-32 px-10 py-8 mx-auto lg:flex-row max-w-m-screen z-50">
					<div className="w-full mt-2 glu2xl:mt-10 glulgx:mt-0 lg:text-left">
						<div>
							{hero.mainTitle && (
								<div className="text-lg lg:pr-10 lg:text-2xl">
									<StructuredText
										data={hero.mainTitle}
										customNodeRules={[
											renderNodeRule(
												isHeading,
												({ node, children, key }) => {
													const HeadingTag = `h${node.level}`;
													return (
														<HeadingTag
															className="mb-5 text-2xl glumd:text-4xl  font-lexend-regular !leading-[2.0rem] glumd:!leading-[3.0rem]"
															key={key}
														>
															{children}
														</HeadingTag>
													);
												}
											),
										]}
										customMarkRules={[
											renderMarkRule(
												'highlight',
												({ children, key }) => (
													<span
														className="text-brand-red-400 pb-1 bg-no-repeat bg-underline bg-bottom bg-[length:100%_6px] md:bg-[length:100%_8px]"
														key={key}
													>
														{children}
													</span>
												)
											),
										]}
									/>
								</div>
							)}
							{hero.mainSubheading && (
								<div className="text-md lg:pr-10 lg:text-xl">
									<StructuredText
										data={hero.mainSubheading}
										customMarkRules={[
											renderMarkRule(
												'highlight',
												({ children, key }) => (
													<span
														className=" text-brand-red-400"
														key={key}
													>
														{children}
													</span>
												)
											),
										]}
									/>
								</div>
							)}
						</div>
						<div className="flex flex-col justify-center mt-8 sm:flex-row sm:justify-start">
							<PBSLink
								to="/elearning/"
								variant="Blue"
								size="Small"
								className="justify-center mt-auto bg-blue-400 text-white"
							>
								{' '}
								Get started for free{' '}
							</PBSLink>
							<Button
								variant="White"
								size="Small"
								className="justify-center z-50 glu2xl:ml-4 glusmss:ml-4 glulgx:ml-4 glumd:ml-2 gluxxs:ml-0 gluxxs:mt-2 glusm:ml-0 glusm:mt-2 mt-auto ml-4"
								onClick={() => setModalOpen(true)}
							>
								Watch video
							</Button>

							{isModalOpen && (
								<ModalWrapper>
									<div
										className="relative w-[90%] glulg:w-7/12 m-auto opacity-100"
										ref={ref}
									>
										{hero.vimeoLink?.providerUid && (
											<VideoPlayer
												videoEmbed={hero.vimeoLink}
												autoPlay
												privateVideoHash={
													privateVideoHash
												}
												locale={locale}
											/>
										)}
									</div>
								</ModalWrapper>
							)}
						</div>

						<div className="text-center mt-10 lg:text-left">
							{locale !== 'en-CA' ? (
								hero.trustpilotReview && (
									<div className="flex items-start my-5 ">
										<TrustpilotBusinessReviewHorizontal
											className="mb-10"
											rating={rating}
										/>
									</div>
								)
							) : (
								<BusinessReviewHorizontal
									className="flex items-start my-5 -ml-3 "
									googleReview={googleReview}
									onlyGR
								/>
							)}
						</div>
						<div>
							<div className="flex flex-col mt-5  glulgx:-mt-12 glu2xl:mt-5 mb-20">
								<div className="flex gap-10">
									{locale !== 'en-AU' &&
										badgesRowOne?.map((badge) => (
											<GatsbyImage
												image={badge.gatsbyImageData}
												alt={badge.alt || ''}
												key={badge.id}
											/>
										))}
								</div>
							</div>
						</div>
					</div>
					<div
						style={{
							overflow: 'hidden',
							width: '220%',
							height: '140%',
							marginTop: '-28%',
							left: '10%',
							transform: 'translateX(-10%)',
							zIndex: '-1',
						}}
					>
						<img
							src="https://www.datocms-assets.com/64336/1744014728-glu-dashboard-laptop-2.png"
							alt="GLU Dashboard"
							style={{ width: 'full' }}
							className="hidden lg:block"
						/>
					</div>
				</div>
			</div>
			<div className="  max-w-m-screen mx-auto z-20 grid grid-cols-4 gap-10 p-10 -mt-20  glu2xl:gap-10 glu2xl:grid-cols-4 glu2xl:-mt-80 glu2xl:p-10  glulgx:gap-10 glulgx:grid-cols-4 glulgx:-mt-60 glulgx:p-10   glusm:-mt-32 glusm:max-w-m-screen glusm:grid-cols-4  glusm:p-5 glusm:gap-2 glusm:mx-auto gluxxs:-mt-44 gluxxs:max-w-m-screen gluxxs:grid-cols-4 gluxxs:p-1 gluxxs:gap-1 gluxxs:mx-auto    glumd:grid-cols-4 glumd:-mt-32 glumd:p-5 glulg:p-10 glulg:-mt-60">
				{[
					{
						title: '250+ HR & Employment Law, Health & Safety Certificated Sessions',
						description: 'Available 24/7',
					},
					{
						title: 'CPD and RoSPA accredited content',
						description: '',
						imageOne:
							'https://www.datocms-assets.com/64336/1693834200-cpd.png',
						imageTwo:
							'https://www.datocms-assets.com/64336/1693834225-rospa.png',
					},
					{
						title: 'Live Weekly Webinars every Wednesday',
						description: 'Catch-Up Library',
					},
					{
						title: 'Immediate Updates on Legislative Changes',
						description: '',
					},
				].map((item, index) => (
					<div
						className="flex flex-col items-center justify-center bg-white shadow-2xl rounded-sm p-10 glusms:p-5 glulgx:p-10 glu2xl:p-10 glusm:p-3 gluxxs:p-3 text-center glumd:p-10"
						key={index.id}
					>
						<h2 className="text-sm glusms:text-md mb-10 glu2xl:text-xl glulgx:text-xl glumd:text-xl glusm:text-xs gluxxs:text-xs">
							{item.title}
						</h2>
						{item.title === 'CPD and RoSPA accredited content' && (
							<div className="flex items-center justify-center gap-16">
								<img
									src={item.imageOne}
									alt="CPD"
									className="hidden w-12 h-12 lg:block"
								/>
								<img
									src={item.imageTwo}
									alt="RoSPA"
									className="hidden w-12 h-12 lg:block"
								/>
							</div>
						)}
						{item.description && (
							<div>
								<div className="flex items-center justify-between pt-4 glu2xl:p-4 glulgx:p-4 gluxxs:p-0 glusm:p-0 border-t font-bold text-bold border-grey-400" />
								<p className="glumd:text-xl glusm:text-xs gluxxs:text-xs glu2xl:text-xl glulgx:text-xl text-lg text-brand-red-400 mt-2">
									{item.description}
								</p>
							</div>
						)}
					</div>
				))}
			</div>
			<div>
				<h1 className="glu2xl:text-4xl glu2xl:mt-8 glumd:text-2xl  glu2xl:-mb-5 glulgx:text-3xl glulg:text-2xl glumdx:text-2xl glumsdsm:text-2xl text-lg text-center mt-10 ">
					Join leading businesses using{' '}
					<span className="text-brand-red-400">GLU</span>...{' '}
				</h1>
			</div>
		</>
	);
};

export default HeroWithCards;
